import { useEffect } from "react";
import { Box } from "@mui/material";
import { useFetchItemLogs } from "features/editor/hooks/useFetchItemLogs";
import { useEditorContext } from "features/editor/context/editor";
import { ITranslationLog } from "features/workspaces/types";

const getAuthor = (logs?: ITranslationLog[]) => {
  const author = logs?.at(0)?.userEmail ?? "";

  // TODO: add sync
  if (["init", "init update"].includes(author)) {
    return null;
  }

  return author;
};

export const Info = () => {
  const { activeItemIndex, list } = useEditorContext();
  const { translation, tags = [] } = list.items[activeItemIndex!] || {};
  const { logs, refetch: refreshLogs } = useFetchItemLogs(translation?.id);

  useEffect(() => {
    refreshLogs();
  }, [translation?.text]);

  const author = getAuthor(logs);

  return (
    <>
      <Box sx={{ mb: 1.5, fontSize: 14 }}>Author: {author ?? "N/A"}</Box>
      {tags.length ? (
        <>
          <Box sx={{ fontSize: 14 }}>Tags:</Box>
          <Box component="ul" p={0} m={0}>
            {tags.map((tag: string, index: number) => (
              <Box
                sx={{ whiteSpace: "pre-wrap" }}
                mb={1.5}
                key={`${tag.trim().replace(" ", "") + index}`}
                component="li"
              >
                {tag}
              </Box>
            ))}
          </Box>
        </>
      ) : (
        <Box sx={{ mb: 1.5 }}>There is no tags for selected item.</Box>
      )}
    </>
  );
};
